export const getBrazilDate = (
  time: 'start' | 'end' = 'start',
  daysOffset = 0
) => {
  const reference = new Date()
  reference.setDate(reference.getDate() + daysOffset)

  const brazilDate = reference.toLocaleString('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  const timeStr = time === 'start' ? '00:00:00' : '23:59:59'
  return new Date(`${brazilDate}T${timeStr}`)
}
